import {
  BOUNDARY_TERRITORY_LABEL_BACKGROUND_DEFAULT_COLOR, BOUNDARY_TERRITORY_LABEL_TEXT_DEFAULT_COLOR,
} from '~/boundary/settings/constants';
import {
  type BoundaryTerritoryGroupSettings, type BoundaryTerritoryLabelStyle, type BoundaryTerritoryLabelValueConfig,
} from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';
import { BoundaryFill } from './boundaryFill.type';

export const getDefaultLabelValueSettings = ({ hideLabels }: Pick<BoundaryTerritoryGroupSettings, 'hideLabels'>): BoundaryTerritoryLabelValueConfig => {
  return {
    showValue: !hideLabels,
    includeLegend: !hideLabels,
    isValueCustom: false,
    labelValueColumnId: null,
    labelValueType: null,
    labelValueAggregationFunction: null,
    labelValueDemographicId: null,
  };
};

const defaultLabelStyle: BoundaryTerritoryLabelStyle = {
  backgroundColor: BOUNDARY_TERRITORY_LABEL_BACKGROUND_DEFAULT_COLOR,
  fontColor: BOUNDARY_TERRITORY_LABEL_TEXT_DEFAULT_COLOR,
};

export const blankBoundaryStyle = {
  color: '#FFFFFF',
  opacity: 0,
  lineColor: '#000000',
  lineWidth: 1,
} as const;

export const defaultBoundaryTerritoryGroupResponseSettings = {
  allow_decimal_ranges: true,
  boundary_fill_type: BoundaryFill.DefaultFill,
  boundary_style: [],
  bucket_distribution: 'equal-count',
} as const;

export const defaultBoundaryTerritoryGroupSettings = {
  allowDecimalRanges: false,
  boundariesAsTerritories: false,
  boundaryFillType: BoundaryFill.DefaultFill,
  boundaryStyle: new Map(),
  boundaryTerritories: [],
  displayName: null,
  emptyIsZero: null,
  metrics: [],
  rangesCount: null,
  hideFillWhenInactive: true,
  disableMapInteraction: false,
  hideLabels: false,
  hideWithoutData: false,
  ignoreFilters: false,
  labelStyle: defaultLabelStyle,
  labelValueConfig: getDefaultLabelValueSettings({ hideLabels: false }),
} satisfies Omit<BoundaryTerritoryGroupSettings, 'boundaryTerritoryType' | 'style' | 'demographicId' | 'bucketDistribution' | 'bucketType' | 'bucketColumnId' | 'calculateBucketFunction'>;
